import React, { memo, useState, useEffect } from 'react';
import styles from './filterDevices.module.scss';
import FilterContent from '../../../shared/components/FilterContent';
import Button from '../../../shared/components/Button';
import Input from '../../../shared/components/Input';
import CustomSelect from '../../../shared/components/CustomSelect';
import DatePicker from '../../../shared/components/DatePicker';
import CreateDevices from '../CreateDevices';
import { useTranslation } from 'react-i18next';
import { defaultStatusOptionsFilter, defaultSubstatusOptionsFilter } from '../../../app/conf';
import { defaultFilters } from '../DevicesLoader/DevicesLoader';
import SVG from 'react-inlinesvg';
import { searchSVG } from '../../../shared/helpers/icons';

const FiltersDevices = ({ 
    setDevicesFilters, 
    getDevicesStatusesRequest,
    getDevicesSubstatusesRequest,
    filters, 
    devices: { fetching, fetchingExport, statuses, substatuses, statusesFetching, substatusesFetching}, 
    getExportDevicesRequest,
    filtersToUseInQuery,
    closePingEventExportDevices
}) => {
    const { t } = useTranslation(['home', 'devices']);
    
    const [defaultStatusOpt, setDefaultStatusOptions] = useState([
        {
            ...defaultStatusOptionsFilter,
            label: t(defaultStatusOptionsFilter.label)
        }
    ]);
    

    
    const [enabledOptions] = useState([
        { value: '', label: 'Habilitación' },
        { value: true, label: 'Habilitado' },
        { value: false, label: 'Deshabilitado' }
    ]);
    
    const [desde, setDesde] = useState(null);
    const [hasta, setHasta] = useState(null);
    const [estado, setEstado] = useState({ ...defaultStatusOpt[0] });

    const [enabled, setEnabled] = useState({ value: '', label: 'Habilitación' });
    const [search, setSearch] = useState('');


    const handleSearch = ev => {
        setSearch(ev.target.value);
    };

    const handleDesde = date => {
        setDesde(date);
    };
    const handleHasta = date => {
        setHasta(date);
    };
    const handleEstado = status => {
        setEstado(status);
        
    };

    const handleEnabled = enabled => {
        setEnabled(enabled);
    };

    const pad2 = n => String(n).padStart(2, '0');
    const formatDate = date => {
        if (!date) {
            return null;
        }
        if (!(date instanceof Date)) {
            return null;
        }
        const y = date.getFullYear();
        const m = pad2(date.getMonth() + 1);
        const d = pad2(date.getDate());
        const formattedDate = `${y}-${m}-${d}`;
        return formattedDate;
    };

    const filterDevices = () => {
        const fromDate = desde ? formatDate(desde) : null;
        const toDate = hasta ? formatDate(hasta) : null;

        const filters = {
            search: search,
            from_created: fromDate,
            to_created: toDate,
            status: estado,
            enabled: enabled
        };
        
        setDevicesFilters(filters);
    };

    const limpiar = () => {
        setSearch('');
        setDesde(null);
        setHasta(null);
        setEstado({ ...defaultStatusOpt[0] });
        setEnabled({ value: '', label: 'Habilitación' });
        setDevicesFilters({});
    };
    
    const exportDevices = () => {
        const timeZone = new Date().getTimezoneOffset();
        const exportFilters = {
            ...defaultFilters,
            ...filtersToUseInQuery,
            tz: timeZone
        };
        getExportDevicesRequest(exportFilters);
    };

    useEffect(() => {
        setSearch(filters.search);
    }, [filters]);

    useEffect(() => {
        return () => closePingEventExportDevices();
    }, [])

    useEffect(() => {
        getDevicesStatusesRequest();
    }, [getDevicesStatusesRequest]);

    useEffect(() => {
        if (statuses && statuses.length) {
            const opts = [
                { ...defaultStatusOptionsFilter, label: t(defaultStatusOptionsFilter.label) },
                ...statuses.map(st => ({
                    _id: st._id,
                    value: st._id,
                    label: st.name
                }))
            ];

            setDefaultStatusOptions(opts);
 
        }
    }, [statuses, t, setDefaultStatusOptions]);


    return (
        <div className={styles.header}>
            <div className={styles.arriba}>
            <Button onClick={exportDevices} className={styles.buttonArchivo} loading={fetchingExport}>
    
   <span>
   <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="18" 
    height="15" 
    viewBox="13 0 40 40" 
    fill="none"
>
    <path 
        d="M24 4V30M24 30L14 20M24 30L34 20M10 36H38" 
        stroke="white" 
        stroke-width="4" 
        stroke-linecap="round" 
        stroke-linejoin="round"
    />
</svg></span> Exportar dispositivos
</Button>

            <CreateDevices />
            </div>
            <div className={styles.abajo}>
            <FilterContent className={styles.filterContent}>
            <div className={styles.searchInput}>
             <Input placeholder="IMEI, proveedor, modelo" value={search} onChange={handleSearch} />
                        <svg 
                            className={styles.searchIcon} 
                            width="16" 
                            height="16" 
                            viewBox="0 0 20 20" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M14 14L11 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>

                <DatePicker
                    selected={desde}
                    onChange={handleDesde}
                    placeholderText="Desde"
                    className={styles.datePicker}
                    placeholder="Desde"
                    dateFormat="dd/MM/yyyy"
                    key={`desde-${desde || 'empty'}`}
                    maxDate={hasta || new Date()}
                    isClearable
                />
                <DatePicker
                    selected={hasta}
                    onChange={handleHasta}
                    placeholder="Hasta"
                    className={styles.datePicker}
                    dateFormat="dd/MM/yyyy"
                    key={`hasta-${hasta || 'empty'}`}
                    minDate={desde}
                    maxDate={new Date()}
                    isClearable
                />
                <CustomSelect
                    options={defaultStatusOpt}
                    value={estado}
                    onChange={handleEstado}
                    placeholder="Estado"
                    className={styles.select}
                    inputFilter
                />
                {/* Comentado el select de subestado */}
                {/* <CustomSelect
                    options={defaultSubstatusOpt}
                    value={subestado}
                    onChange={handleSubestado}
                    placeholder="Subestado"
                    className={`${styles.select} ${!estado || estado._id === defaultStatusOptionsFilter._id ? styles.disabled : ''}`}
                    inputFilter
                    readOnly={!estado || estado._id === defaultStatusOptionsFilter._id}
                /> */}
                
                {/* Agregado el select de habilitación */}
                <CustomSelect
                    options={enabledOptions}
                    value={enabled}
                    onChange={handleEnabled}
                    placeholder="Habilitación"
                    className={styles.select}
                    inputFilter
                />
                <Button onClick={limpiar} className={styles.buttonLimpiar}>
                    Limpiar
                </Button>
                <Button onClick={filterDevices} className={styles.buttonFilter} loading={fetching}>
                    Aplicar
                </Button>
                
                
            </FilterContent>
        
            </div>
           
        </div>
    );
};

export default memo(FiltersDevices);
